import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filter-controls"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-9" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "col-lg-4 col-12" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "btn-group flex-wrap",
  role: "group"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_13 = {
  class: "btn-group flex-column flex-md-row w-100",
  role: "group",
  "aria-label": "Location filter"
}
const _hoisted_14 = ["id", "checked", "onChange"]
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_17 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_18 = ["checked"]
const _hoisted_19 = {
  class: "btn btn-outline-primary filter-button-sm",
  for: "date-day1"
}
const _hoisted_20 = ["checked"]
const _hoisted_21 = {
  class: "btn btn-outline-primary filter-button-sm",
  for: "date-day2"
}
const _hoisted_22 = { key: 1 }

import { ref, computed, onMounted, watch } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import AgendaEntry from "@/components/AgendaEntry.vue"
import MeetingEntry from "@/components/MeetingEntry.vue"
import JitsiCall from "@/components/jitsi/JitsiCall.vue"
import _ from "lodash"
import type { AgendaPoint, Meetings } from "@/store/i/types"
import type { JitsiCallRequest } from "@/store/member/types"
import { AgendaPoint as ImportedAgendaPoint } from '@/store/i/types'

// Props
type EventTypeKey = string; // Oder spezifischer, falls bekannt
type EventTypes = Record<EventTypeKey, boolean>;
type Days = { day1: boolean; day2: boolean };
type LocationFilters = Record<string, boolean>;

// Event Type Mapping

export default /*@__PURE__*/_defineComponent({
  __name: 'Agenda',
  props: {
    agendatype: {},
    location: {},
    showFilter: { type: Boolean },
    showDates: { type: Boolean },
    searchText: {},
    activeFilters: {},
    day: {}
  },
  emits: ['update:searchText', 'update:activeFilters'],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emit Definition für Updates (Jetzt definiert)
const emit = __emit

// Store, Route, Router
const store = useStore()
const route = useRoute()

// Reactive State
const searchtext = ref('')

// Inline Typdefinitionen (da sie nicht exportiert werden)
const eventTypeMap: Record<EventTypeKey, number> = {
  networking: 4,
  exhibitor_events: 5,
  plenary_sessions: 6,
  breakout_sessions: 7
}

const currentCall = computed<JitsiCallRequest | undefined>(() => store.state.members.currentCall)

const pickusercall = async (cp: Meetings) => {
  // Video-Call-Funktionalität wurde entfernt, stattdessen zeigen wir einen Hinweis an
  store.commit("i/addToast", {
    header: {de: "Hinweis", en: "Information"},
    msg: {
      de: 'Videoanrufe sind in dieser Version nicht verfügbar.',
      en: 'Video calls are not available in this version.'
    },
    validforroom: "event-general",
    got: new Date(),
    hidden: false,
    showfor: 5000,
    alert_type: 'info'
  })
}

onBeforeRouteLeave((to, from, next) => {
  if (store.state.members.currentCall && !store.getters['i/forcedToPlenum'] && !store.getters['i/redirectToPlenum']) {
    const confirmres = window.confirm(store.getters.i18n({
      de: "Wenn Sie jetzt den Stand verlassen, wird Ihr Gespräch beendet.",
      en: "If you are leaving the booth now, your call will be ended."
    }))
    if (confirmres) {
      next()
    } else {
      next(false)
    }
  } else {
    next()
  }
})


// Active Filters State
const activeFilters = ref({
  eventTypes: {} as EventTypes, 
  days: { day1: true, day2: true } as Days, 
  locations: {} as LocationFilters
})

// Computed Properties
const noDaysSelected = computed(() => {
  return !activeFilters.value.days.day1 && !activeFilters.value.days.day2;
})

const filterItems = (items: AgendaPoint[]) => {
  const swords = _.map(
      _.words(searchtext.value),
      s => new RegExp(_.escapeRegExp(s), 'iu')
  )

  localStorage.setItem("TextFilter", searchtext.value)

  const activeEventTypeFilters: EventTypeKey[] = Object.entries(activeFilters.value.eventTypes)
      .filter(([_key, value]) => value)
      .map(([key, _value]) => key as EventTypeKey)

  const lookForEventTypeNumber = activeEventTypeFilters.map((k) => eventTypeMap[k])
  
  const activeLocationFilters = Object.entries(activeFilters.value.locations)
      .filter(([_key, value]) => value)
      .map(([key, _value]) => key)

  return _.filter(
      items,
      (item) => {
        return (swords.length === 0 || swords.some((r) => r.test(item.title + ' ' + item.speakers)))
            && (lookForEventTypeNumber.length === 0 || lookForEventTypeNumber.includes(item.eventtype))
            && (activeLocationFilters.length === 0 || 
               (item.location && typeof item.location === 'string' && 
                activeLocationFilters.includes(item.location)))
      }
  )
}


/*
 ERSTMAL AUSKOMMENTIERT DA ZU KLÄREN IST WELCHE DATEN 2025 ES SEIN SOLLEN UND OB DAS HARDGECODET BLEIBT
 OHNE AUSKOMMENTIEREN BEKOMMT MAN SONST ERSTMAL MIT DEN TESTDATEN NIX ANGEZEIT!!!
*/

/*
const agendaPointsDay1 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Mon Jun 17 2024"
  )

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    )
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Mon Jun 17 2024" && ap.show_video
    )
  }

  return filterItems(items)
})

const agendaPointsDay2 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Tue Jun 18 2024"
  )

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    )
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Tue Jun 18 2024" && ap.show_video
    )
  }

  return filterItems(items)
})
*/

const agendaPointsDay1 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => {
        // Filtere nach 7. Juli 2025
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && // Juli = 6 (0-basiert)
               itemDate.getFullYear() === 2025;
      }
  );

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    );
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.show_video
    );
  }

  return filterItems(items);
})

const agendaPointsDay2 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => {
        // Filtere nach 8. Juli 2025
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && // Juli = 6 (0-basiert)
               itemDate.getFullYear() === 2025;
      }
  );

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && 
                            new Date(ap.enddate).getTime() > new Date().getTime()
    );
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.show_video
    );
  }

  return filterItems(items);
})

// Meetings computed properties
const meetings1 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 1 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 2 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings3 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 3 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings4 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 4 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings1_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 1 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings2_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 2 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings3_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 3 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings4_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 4 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

// Filtert die Agenda-Items, um sicherzustellen, dass nur gültige AgendaPoint-Objekte verwendet werden
const filteredAgendaPointsDay1 = computed(() => {
  if (!Array.isArray(agendaPointsDay1.value)) return [];
  
  // Filtere zuerst nach Location, wenn eine angegeben ist
  let items = agendaPointsDay1.value.filter((item): item is AgendaPoint => 
    item !== null && typeof item === 'object' && 'objvalueid' in item
  );

  // Wende Filter an
  if (props.location) {
    items = items.filter(item => item.location === props.location);
  }

  if (props.searchText) {
    const searchLower = props.searchText.toLowerCase();
    items = items.filter(item => 
      item.title.toLowerCase().includes(searchLower) ||
      (item.subtitle?.toLowerCase().includes(searchLower)) ||
      (item.hosted_by?.toLowerCase().includes(searchLower))
    );
  }

  // Sortiere nach Startzeit
  items = _.sortBy(items, [
    item => new Date(item.startdate).getTime()
  ]);

  // Berechne die Position basierend auf der Startzeit
  return items.map(item => {
    const startTime = new Date(item.startdate);
    const endTime = new Date(item.enddate);
    const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const duration = (endTime.getTime() - startTime.getTime()) / (1000 * 60); // Dauer in Minuten
    
    return {
      ...item,
      topPosition: `${((startMinutes - 8 * 60) / 15) * 3}rem`, // 3rem pro 15-Minuten-Slot
      height: `${(duration / 15) * 3}rem` // Höhe basierend auf der Dauer
    };
  });
});

const filteredAgendaPointsDay2 = computed(() => {
  if (!Array.isArray(agendaPointsDay2.value)) return [];
  
  // Filtere zuerst nach Location, wenn eine angegeben ist
  let items = agendaPointsDay2.value.filter((item): item is AgendaPoint => 
    item !== null && typeof item === 'object' && 'objvalueid' in item
  );

  // Wende Filter an
  if (props.location) {
    items = items.filter(item => item.location === props.location);
  }

  if (props.searchText) {
    const searchLower = props.searchText.toLowerCase();
    items = items.filter(item => 
      item.title.toLowerCase().includes(searchLower) ||
      (item.subtitle?.toLowerCase().includes(searchLower)) ||
      (item.hosted_by?.toLowerCase().includes(searchLower))
    );
  }

  // Sortiere nach Startzeit
  items = _.sortBy(items, [
    item => new Date(item.startdate).getTime()
  ]);

  // Berechne die Position basierend auf der Startzeit
  return items.map(item => {
    const startTime = new Date(item.startdate);
    const endTime = new Date(item.enddate);
    const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const duration = (endTime.getTime() - startTime.getTime()) / (1000 * 60); // Dauer in Minuten
    
    return {
      ...item,
      topPosition: `${((startMinutes - 8 * 60) / 15) * 3}rem`, // 3rem pro 15-Minuten-Slot
      height: `${(duration / 15) * 3}rem` // Höhe basierend auf der Dauer
    };
  });
});

// Computed Properties für Event Types und Locations (mit Debugging)
const eventTypes = computed(() => {
  const types: Record<string, number> = {};
  const agendaPoints = store.getters['i/orderedAgendaPoints'] || [];
  if (!Array.isArray(agendaPoints) || agendaPoints.length === 0) {
      return {};
  }
  agendaPoints.forEach((point: AgendaPoint, index: number) => {
    if (point) {
      const eventTypeNumber = point.eventtype;
      const typeKey = getEventTypeKey(eventTypeNumber); 
      if (typeKey) {
        types[typeKey] = (types[typeKey] || 0) + 1;
      }
    } 
  });
  return types;
});

const locationTypes = computed(() => {
  const locations: Record<string, number> = {};
  const agendaPoints = store.getters['i/orderedAgendaPoints'] || [];
   if (!Array.isArray(agendaPoints) || agendaPoints.length === 0) {
      return {};
  }
  agendaPoints.forEach((point: AgendaPoint, index: number) => {
    if (point && point.location && typeof point.location === 'string') {
      const locationString = point.location.trim();
      if (locationString !== '') {
        locations[locationString] = (locations[locationString] || 0) + 1;
      }
    }
  });
   const sortedLocations: Record<string, number> = {};
   Object.keys(locations).sort().forEach(key => {
       sortedLocations[key] = locations[key];
   });
  return sortedLocations; 
});

// Funktion zum Konvertieren von Eventtyp-Nummern in Schlüssel (korrigiert/überprüft)
const getEventTypeKey = (typeNumber: number): EventTypeKey | null => {
  const map: Record<number, EventTypeKey> = {
    // Korrektes Mapping basierend auf eventTypeMap oben
    6: 'plenary_sessions',  
    7: 'breakout_sessions', 
    5: 'exhibitor_events',  
    4: 'networking'         
  };
  const key = map[typeNumber];
  return key || null;
};

// Funktion gibt die originalen etX-Klassennamen zurück (bleibt so)
const getEventTypeClass = (typeKey: EventTypeKey): string => {
  const number = eventTypeMap[typeKey]; // Holt 4, 5, 6, oder 7
  return number ? `et${number}` : 'et-default'; // Originale Klasse (z.B. et6)
};

// Hilfsfunktion zum Formatieren der Schlüssel
const formatTypeKey = (key: string): string => {
    return key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

// Methods
const clearFilter = () => {
  searchtext.value = '' 
  emit('update:searchText', ''); 
  filtersInitialized = false; 
  initializeFilters(); 
}

// NEUE Allgemeine Toggle-Funktion
const toggleFilter = (filterType: 'eventTypes' | 'locations' | 'days', key: string) => {
    if (filterType === 'days') {
        if (key === 'day1' || key === 'day2') {
            activeFilters.value.days[key] = !activeFilters.value.days[key];
        }
    } else {
        if (activeFilters.value[filterType]) {
            activeFilters.value[filterType][key] = !activeFilters.value[filterType][key];
        }
    }
    emit('update:activeFilters', activeFilters.value);
};

const toggleDayFilter = (type: keyof Days) => {
  activeFilters.value.days[type] = !activeFilters.value.days[type]
  localStorage.setItem("DayFilter", JSON.stringify(activeFilters.value.days))
}

const toggleLocationFilter = (loc: string) => {
  // Sicherstellen, dass der Key existiert bevor umgeschaltet wird
  if (activeFilters.value.locations.hasOwnProperty(loc)) {
      activeFilters.value.locations[loc] = !activeFilters.value.locations[loc];
  } else {
      // Falls Key noch nicht existiert (sollte nicht vorkommen), initialisieren
      activeFilters.value.locations[loc] = false; // Abwählen initialisiert
  }
  localStorage.setItem("LocationFilter", JSON.stringify(activeFilters.value.locations))
}


// Navigation Guard
onBeforeRouteLeave((to, from, next) => {
  if (store.state.members.currentCall && !store.getters['i/forcedToPlenum'] && !store.getters['i/redirectToPlenum']) {
    const confirmres = window.confirm(store.getters.i18n({
      de: "If you are leaving the booth now, your call will be ended.",
      en: "If you are leaving the booth now, your call will be ended."
    }))
    if (confirmres) {
      next()
    } else {
      next(false)
    }
  } else {
    next()
  }
})

// Angepasste initializeFilters Funktion
let filtersInitialized = false; // Flag beibehalten
const initializeFilters = () => {
  if (filtersInitialized) {
      return; 
  }
  const initialEventTypes: Record<string, boolean> = {};
  const initialLocations: Record<string, boolean> = {};

  Object.keys(eventTypes.value).forEach(key => {
    initialEventTypes[key] = true; 
  });

  Object.keys(locationTypes.value).forEach(key => {
    initialLocations[key] = true; 
  });

  const initialDays = { day1: true, day2: true };

  activeFilters.value = {
      eventTypes: initialEventTypes,
      days: initialDays,
      locations: initialLocations
  };

  filtersInitialized = true; 
  emit('update:activeFilters', activeFilters.value);
};

// Watcher, der initializeFilters auslöst (nur wenn Daten bereit sind)
watch([eventTypes, locationTypes], ([newEventTypes, newLocationTypes]) => {
    if (!filtersInitialized && 
        Object.keys(newEventTypes).length > 0 && 
        Object.keys(newLocationTypes).length > 0) {
        initializeFilters();
    }
}, { immediate: false }); // Nicht sofort ausführen, erst bei Änderung

// Computed property für gefilterte Events (wird von Standard-Ansicht gebraucht)
const filteredEvents = computed<AgendaPoint[]>(() => {
  // Nur relevant, wenn nicht Timeline
  if (props.agendatype === 'timeline') return []; 

  let items: AgendaPoint[] = [];
  
  // Sicherstellen, dass agendaPointsDay1.value ein Array von AgendaPoint ist
  const day1Points = Array.isArray(agendaPointsDay1.value) 
                      ? agendaPointsDay1.value.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item)
                      : [];
  // Sicherstellen, dass agendaPointsDay2.value ein Array von AgendaPoint ist
  const day2Points = Array.isArray(agendaPointsDay2.value) 
                      ? agendaPointsDay2.value.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item)
                      : [];

  if (activeFilters.value.days.day1) {
      items = items.concat(day1Points);
  }
  if (activeFilters.value.days.day2) {
      items = items.concat(day2Points);
  }
  
  // filterItems erwartet AgendaPoint[] und wendet weitere Filter an
  const filtered = filterItems(items); 
  // Letzte Sicherheitsprüfung für den Linter
  return filtered.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item);
});

// Lifecycle Hooks
onMounted(async () => {
  if (!store.getters['i/orderedAgendaPoints'] || store.getters['i/orderedAgendaPoints'].length === 0) {
      await store.dispatch("i/fetchAgenda");
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.agendatype === 'filter')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("input", {
                  placeholder: "Search title or speaker name",
                  type: "search",
                  value: props.searchText,
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchText', ($event.target as HTMLInputElement).value))),
                  class: "form-control"
                }, null, 40, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-lg-8 col-12" }, null, -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "resetfilter btn btn-outline-primary float-end",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (clearFilter()))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fal fa-trash" }, null, -1),
                    _createTextVNode(" Clear Filter ")
                  ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fw-bold mb-2 mt-3" }, "Event type", -1)),
                (Object.keys(eventTypes.value).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventTypes.value, (count, typeKey) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: typeKey,
                          class: _normalizeClass(["btn me-2 mb-2 filter-button-sm", [getEventTypeClass(typeKey)]]),
                          onClick: ($event: any) => (toggleFilter('eventTypes', typeKey))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['me-1', activeFilters.value.eventTypes[typeKey] ? 'fas fa-check-circle' : 'far fa-circle'])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(formatTypeKey(typeKey)) + " (" + _toDisplayString(count) + ") ", 1)
                        ], 10, _hoisted_10))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_11, "No event types found."))
              ]),
              (Object.keys(locationTypes.value).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "fw-bold mb-2 mt-3" }, "Location", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationTypes.value, (count, loc) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: loc }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "btn-check",
                            id: `loc-filter-${loc.replace(/\s+/g, '-')}`,
                            checked: activeFilters.value.locations[loc],
                            onChange: ($event: any) => (toggleLocationFilter(loc)),
                            autocomplete: "off"
                          }, null, 40, _hoisted_14),
                          _createElementVNode("label", {
                            class: "btn btn-outline-secondary filter-button-sm",
                            for: `loc-filter-${loc.replace(/\s+/g, '-')}`
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(['me-1', activeFilters.value.locations[loc] ? 'fas fa-check-circle' : 'far fa-circle'])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(loc), 1)
                          ], 8, _hoisted_15)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (props.showDates !== false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "fw-bold mb-2 mt-3" }, "Date", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "btn-check",
                        id: "date-day1",
                        checked: activeFilters.value.days.day1,
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (toggleDayFilter('day1')))
                      }, null, 40, _hoisted_18),
                      _createElementVNode("label", _hoisted_19, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['me-1', activeFilters.value.days.day1 ? 'fas fa-check-circle' : 'far fa-circle'])
                        }, null, 2),
                        _cache[8] || (_cache[8] = _createTextVNode(" Monday, July 7, 2025 "))
                      ]),
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "btn-check",
                        id: "date-day2",
                        checked: activeFilters.value.days.day2,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (toggleDayFilter('day2')))
                      }, null, 40, _hoisted_20),
                      _createElementVNode("label", _hoisted_21, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['me-1', activeFilters.value.days.day2 ? 'fas fa-check-circle' : 'far fa-circle'])
                        }, null, 2),
                        _cache[9] || (_cache[9] = _createTextVNode(" Tuesday, July 8, 2025 "))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEvents.value, (ae) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `list-${ae.objvalueid}`
            }, [
              _createVNode(AgendaEntry, {
                ae: ae,
                agendatype: props.agendatype
              }, null, 8, ["ae", "agendatype"])
            ]))
          }), 128))
        ])),
    (_unref(store).state.members.currentCall)
      ? (_openBlock(), _createBlock(JitsiCall, {
          key: 2,
          type: "member"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})